import { useLoader } from '@react-three/fiber';
import { memo } from 'react';
import { MeshStandardMaterial, TextureLoader } from 'three';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';

type Props = {
  pos?: Array<number>;
  rot?: Array<number>;
  type?: number;
};

const MushroomTemplate = ({
  pos = [0.77, 0.046, 0.35],
  rot = [0, Math.PI / 2, 0],
  type = 0,
}: Props) => {
  const obj = useLoader(
    OBJLoader,
    type === 0
      ? '/plant/shrooms1.obj'
      : type === 1
      ? 'plant/shrooms2.obj'
      : type === 2
      ? 'plant/shrooms3.obj'
      : type === 3
      ? 'plant/shrooms4.obj'
      : type === 4
      ? 'plant/shrooms5.obj'
      : type === 5
      ? 'plant/shrooms6.obj'
      : type === 6
      ? 'plant/shrooms7.obj'
      : type === 7
      ? 'plant/shrooms8.obj'
      : type === 8
      ? 'plant/shrooms9.obj'
      : type === 9
      ? 'plant/shrooms10.obj'
      : type === 10
      ? 'plant/shrooms11.obj'
      : type === 11
      ? 'plant/shrooms12.obj'
      : type === 12
      ? 'plant/shrooms13.obj'
      : type === 13
      ? 'plant/shrooms14.obj'
      : 'plant/shrooms14.obj'
  );
  const texture = useLoader(TextureLoader, '/plant/template.jpg');
  obj.traverse((child: any) => {
    if (child.isMesh) {
      child.material = new MeshStandardMaterial({
        map: texture,
        roughness: 0.1,
      });
    }
  });
  return (
    <primitive
      object={obj.clone()}
      scale={[0.0003, 0.0003, 0.0003]}
      position={[pos[0], pos[1], pos[2]]}
      rotation={[rot[0], rot[1], rot[2]]}
    />
  );
};

export default memo(MushroomTemplate);
